import React, {Component} from 'react'
import styled from '@emotion/styled'
import {cloudRefiner} from '../../../../defaults/cloudMaker'
import MasonryCloud from '../chapters/MasonryCloud'

import sv from '../../../../styles/styles'

// STYLE ##########################################################

const Chapter = styled(`div`)`
  padding: 8px;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  ${sv.box};
  color: transparent;
`;

const ChapterContent = styled(`div`)`
  transition: border .2s ease-out;
  height: 100%;
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  background: #222;
  border: 2px solid;
  ${sv.box};
  ${sv.flexColumn};
  cursor: pointer;
  &:hover {
    border-color: ${sv.colors.cta};
  }
`;

const ChapterHeader = styled(`div`)`
  ${sv.flexCenter};
  ${sv.label};
  width: 24px;
  color: ${sv.colors.subtleLight};
  flex: 0;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(255,255,255,.1);
  margin: 0 auto 8px auto;
`;

const Cloud = styled(`div`)`
  flex: 1;
`;

// COMPONENT ##########################################################

class UnifiedChapter extends Component {

  state = {
    cloud: [],
    cloudContainerHeight: 0
  };

  componentDidMount() {
	  this.updateCloud();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const chapWidthChanged = prevProps.chapterWidth !== this.props.chapterWidth;
    if (chapWidthChanged) {
      this.updateCloud();
    }
  };

	updateCloud() {
		const rowCount = 3;
		const wordsPerRow = Math.floor(this.props.chapterWidth/100);

		if(wordsPerRow > 0) {
			const wordCount = rowCount*wordsPerRow;
			const newCloud = cloudRefiner(this.props.cloud, wordCount);
			this.setState({
				cloud: newCloud,
				cloudContainerHeight: this.cloudContainer.offsetHeight
			});
		}
	}

  render() {

    return (
      <Chapter height={this.props.chapterHeight} width={this.props.chapterWidth}>
        <ChapterContent onClick={() => this.props.goToChapter(this.props.chapterNumber)}>
          <ChapterHeader>{this.props.chapterNumber}</ChapterHeader>
          <Cloud ref={elm => this.cloudContainer = elm}>
            <MasonryCloud
              cloud={this.state.cloud}
              updateCloud={this.updateCloud}
              isTableOfContents={true}
              parentHeight={this.state.cloudContainerHeight}
              chapterWidth={this.props.chapterWidth}
            />
          </Cloud>
        </ChapterContent>
      </Chapter>
    )
  }
}

export default UnifiedChapter
